import API from "./API"

export const getRewardsPhotoApi = async (payload) => {
    try {
        const response = await API.get(`/rewards/photos/delivery?dailyTaskCompletionId=${payload}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getRewardsFiltersApi = async (payload) => {
    try {
        const response = await API.get('/rewards/filter/list');
        return response;
    } catch (error) {
        throw error;
    }
}

export const getRewardsTasksApi = async (payload) => {
    try {
        const response = await API.get('/rewards/daily/tasks');
        return response;
    } catch (error) {
        throw error;
    }
}

export const getRewardsUsersApi = async (payload) => {
    try {
        const response = await API.get(`/rewards/users/list?page=${payload?.page || 0}&size=${payload?.size || 10}&sortDir=${payload?.sortdir || ''}&sortBy=${payload?.sortby || ''}&rewardStatus=${payload?.rewardStatus || ''}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const generateRewardPdfApi = async (payload) => {
    try {
        const response = await API.post(`/generate/reward/pdf?userId=${payload?.userId || 0}&accountId=${payload?.accountId || 0}`);
        return response;
    } catch (error) {
        throw error;
    }
}